module.exports = __webpack_public_path__ + "img/latitude-interest-free-logo.71690c08.svg";